import { createAction, createReducer } from "@reduxjs/toolkit";

export const setAlertMessage = createAction("alert/setAlertMessage");
export const setAlert = createAction("alert/setAlert");

export const alertReducer = createReducer(
  {
    alertMessage: null,
    closeAlert: false,
    showAlert: false,
    type: "",
    title: "",
    message: "",
  },
  {
    [setAlertMessage]: (state, action) =>
      (state = {
        ...state,
        alertMessage: action.payload,
      }),
    [setAlert]: (state, action) =>
      (state = {
        ...state,
        showAlert: action.payload.alert,
        type: action.payload.type ?? "",
        title: action.payload.title ?? "",
        message: action.payload.message ?? "",
      }),
  }
);
